exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-control-wrap .upload-type-radio[data-v-78f5affd] {\n  padding: 10px 0;\n}\n.upload-control-wrap .upload-type-radio .el-radio[data-v-78f5affd] {\n  background-color: #fff;\n}\n.upload-control-wrap .res-form .el-form-item[data-v-78f5affd] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78f5affd","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/uploadImage/index.vue
// module id = 1146
// module chunks = 7